const extractPrefix = '/static/';
const extractPrefixLength = extractPrefix.length;
export const extractKeyFromId = (id: string): string =>
	id.substr(extractPrefixLength + id.indexOf(extractPrefix));
